<template>
  <div class="logo-wrap">
    <div style="width: 100%;height: auto;padding: 7px 13x; overflow: hidden;">
      <img style="width: 100%;height: auto; display: block" :src="logo">
    </div>
  </div>
</template>

<script>
import url from '@/assets/logo.png'
// import { searchUserList } from '@/api/auth/user'

export default {
  name: 'Logo',
  data () {
    return {
      logo: ''
    }
  },
  async created() {
    try {
      const logo = localStorage.getItem('logo')
      this.logo = logo || url
    } catch(e) {
      console.log(e)
      this.logo = url
    }
  }
}
</script>

<style scoped>
  .logo-wrap {
    /* height: 64px; */
    background-color: #001529;
    padding: 10px 20px;
    /* border-bottom: 1px solid #e8e8e8; */
  }
</style>
